import { useEffect, useContext } from "react"
import { useHistory, withRouter } from "react-router-dom"
import { LangContext } from "./LangContext"

const AppLangSwitch = ({ match }) => {
	const history = useHistory()
	const [lang, setLang] = useContext(LangContext)

	useEffect(() => {
		if (!window.location.search.includes("?lang=en-US") && !window.location.search.includes("?lang=en-us")) {
			setLang("fi")
			document.documentElement.lang = "fi"
		} else if (window.location.search.includes("?lang=en-US") || window.location.search.includes("?lang=en-us")) {
			setLang("en-US")
			document.documentElement.lang = "en-US"
		}
	}, [lang, history, match, setLang])

	return null
}

export default withRouter(AppLangSwitch)
